// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ts-0";
export var checkoutRateBadgeLink = "_ts-1";